export default "__VITE_ASSET__CX7t4g50__"